var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon success"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47754 2 2 6.47705 2 12C2 17.5229 6.47754 22 12 22C17.5225 22 22 17.5229 22 12C22 6.47705 17.5225 2 12 2ZM5.70703 11.793C5.31641 12.1836 5.31641 12.8164 5.70703 13.207L9.29297 16.793C9.68359 17.1836 10.3164 17.1836 10.707 16.793L18.293 9.20703C18.6836 8.81641 18.6836 8.18359 18.293 7.79297L18.207 7.70703C17.8164 7.31641 17.1836 7.31641 16.793 7.70703L10 14.5L7.20703 11.707C7.0459 11.5459 6.84375 11.4512 6.63379 11.4229C6.33594 11.3828 6.02246 11.4775 5.79297 11.707L5.70703 11.793Z",
    fill: "#28A879"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1fb355f6331d45b25da62bffc883a8aa.svg";
export { ForwardRef as ReactComponent };